import { Link } from "react-router-dom";

const Page404 = () => (
  <div className="p-10 text-center">
    <p className="text-base font-semibold text-orange-600">404</p>
    <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
      Page not found
    </h1>
    <p className="mt-6 text-base leading-7 text-gray-600">
      Sorry, we couldn’t find the page you’re looking for.
    </p>
    <div className="mt-10 flex items-center justify-center gap-x-6">
      <Link
        to="/"
        className="rounded-md bg-orange-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-orange-600"
      >
        See all open roles
      </Link>
    </div>
  </div>
);

export default Page404;
